import { useLayoutEffect } from "react";

export const useAnimationLayout = (wrapperRef, animationCb, observer) => {
    useLayoutEffect(() => {
        if (typeof animationCb === "function" && wrapperRef.current) {
            // Delay to ensure DOM is ready after page transitions
            const timer = setTimeout(() => {
                animationCb(wrapperRef);
            }, 200);

            return () => {
                clearTimeout(timer);
            };
        } else if (typeof animationCb !== "function") {
            console.warn("animationCb is not a function");
        }
    }, [wrapperRef, animationCb]);
};
